export default __webpack_public_path__ + "static/media/FAQ_6_2.abe72b57.png";